export default __webpack_public_path__ + "static/media/24.e14982cc.jpg";